export const siteversion = {
  version: '2.1.12',
};
